import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { CacheService } from './cache.service';
import { Organization } from '../model/classes/organization.class';

@Injectable()
export class OrganizationService {

  url = "api/organizationConfiguration/"
  
  constructor(private sxHttp: SxHttpService, private cacheService: CacheService) { }

  /**
   * Retorna un sistema desde el backend
   * @param codigo El codigo del Sistema a buscar
   */
  getOrganization(code: string, checkDisabled: boolean): Observable<Organization> {
    const req = {}
    req['organizationCode'] = code;
    req['checkDisabled'] = checkDisabled;

    return this.sxHttp
      .get( this.url + code, req)
      .map(result => result.json().data as Organization);
  }

  /**
   * Create a New Subscription
   *
   * @param subscriptionCode Subscription Code for new Subscription
   * @param organizationCode Organizacition Code for new Subscription
   */
  create(organizationCode: string): Promise<any> {
    const newOrganization = {
      Description: 'Enter the name of the Organization',
      OrganizationCode: organizationCode
    };

    return this.sxHttp
      .post(this.url, newOrganization)
      .toPromise()
  }

  /**
   * Edita un sistema existente el backend
   */
  editarOrganizacion(organizationCode: string, data: any): Promise<Organization> {
    delete data['completitud'];
    return this.sxHttp
      .put( this.url + organizationCode, data)
      .toPromise()
      .then(response =>
        response.json().data as Organization
      );
  }

  /**
   * Elimina un sistema existente en el backend
   */
  eliminarSistema(id: string): Observable<any> {
    return this.sxHttp
      .delete(`${this.url}${id}`)
      .map(result => result.json().data);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/organization.service.ts